import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import DefaultLayout from "src/layouts/default";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

// JWT
const UsersListPage = lazy(() => import("src/pages/users/list"));
// ----------------------------------------------------------------------

export const usersRoutes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.users.root,
        element: <UsersListPage />,
      },
    ],
  },
];
